<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-body">
        <div *ngIf="loading; else userInfo">
          <app-loading-spinner>Fetching user details</app-loading-spinner>
        </div>

        <ng-template #userInfo>
          <app-user-info
            [user]="user"
            (updateUserRoles)="updateUserRoles($event)"
            [isUpdatingRole]="isUpdatingRole"
            [userPermissions]="userPermissions$ | async"
            [userRoles]="userRoles$ | async"
          ></app-user-info>

          <app-user-mfa
            [user]="user"
            [google]="user.use_google"
            [mobile]="user.use_mfa"
            (removeMfaVerify)="removeMfaVerify()"
          ></app-user-mfa>

          <app-user-blocked
            [user]="user"
            [isUnblockingUser]="isUnblockingUser"
            [canBlock]="canUserBeBlocked && canActingUserBlock"
            (deleteBlockedByLogin)="deleteBlockedByLogin(user)"
            (blockUser)="blockUser()"
          ></app-user-blocked>

          <button
            class="btn btn-success invitation-link"
            [ngClass]="{
              disabled:
                !(loggedInUserHasInvitationLinkPermission$ | async) ||
                selectedUserIsInternalApsisUser
            }"
            appInvitationLinkModal
            [disabled]="
              !(loggedInUserHasInvitationLinkPermission$ | async) ||
              selectedUserIsInternalApsisUser
            "
            [ngbTooltip]="
              selectedUserIsInternalApsisUser
                ? 'This functionality is not supported for APSIS ONE internal users due to security reasons'
                : !selectedUserIsInternalApsisUser &&
                  !(loggedInUserHasInvitationLinkPermission$ | async)
                ? 'This functionality is available for SOC team only, please contact them if you need to request a new invitation link'
                : ''
            "
            (requestInvitationLink)="requestInvitationLink()"
          >
            <i class="fas fa-plus"></i>Request invitation link
          </button>
        </ng-template>
      </div>
    </div>
    <div class="card" *ngIf="!loading">
      <div class="card-body">
        <app-user-ui-preferences [user]="user"></app-user-ui-preferences>
      </div>
    </div>
  </div>
</div>

<div *ngIf="user">
  <h3>
    <i class="fas fa-address-book"></i>
    {{ staffUserAccounts.length ? 'Own Accounts' : 'Accounts' }}
  </h3>
  <div class="grid-container">
    <ng-container *ngFor="let account of customerAccounts">
      <app-user-account-preview
        [accountCategories]="accountCategories"
        class="grid-item"
        [account]="account"
        [userName]="user.name"
        [userId]="user.userId"
      ></app-user-account-preview>
    </ng-container>
  </div>

  <div *ngIf="staffUserAccounts.length">
    <h3>
      <app-svg-icon icon="a-logo" width="27"></app-svg-icon> Staff User Accounts
    </h3>

    <div class="grid-container" id="staff-user-accounts">
      <ng-container *ngFor="let account of staffUserAccounts">
        <app-user-account-preview
          class="grid-item"
          [account]="account"
          [userName]="user.name"
          [userId]="user.userId"
          [showGoToAccountLink]="isCurrentUser"
          [accountCategories]="accountCategories"
        ></app-user-account-preview>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #blockUserBodyTemplate>
  <ng-container *ngIf="blockUserModalRef && !blockUserLoading"
    ><div class="block-user-modal-body">
      <ng-container *ngIf="!blockUserError; else contactAu">
        <header><strong>Preview of the actions</strong></header>
        <ng-container *ngIf="user?.roles?.length">
          <header>The following user roles will be removed:</header>
          <section>
            <ul>
              <li *ngFor="let role of user.roles">
                {{ role }}
              </li>
            </ul>
          </section>
        </ng-container>
        <ng-container *ngIf="accountToolInfo?.length">
          <header>
            {{ user.name }} and their permissions will be removed from the
            following One accounts:
          </header>
          <ul class="accounts">
            <li *ngFor="let info of accountToolInfo">
              <section>
                <header>Account: {{ info.accountName }}</header>
              </section>
              <section *ngFor="let toolPermission of info.toolPermissions">
                <header>{{ toolPermission.toolId }}</header>
                <ul>
                  <li *ngFor="let permission of toolPermission.permissions">
                    {{ permission }}
                  </li>
                </ul>
              </section>
            </li>
          </ul>
        </ng-container>
        <header>Auth0 user {{ userId }} will be blocked</header>
      </ng-container>

      <ng-template #contactAu>Contact AU</ng-template>
    </div></ng-container
  >
</ng-template>
